import * as Sentry from '@sentry/browser'
import once from 'lodash/once'
import { EVENTS_CATEGORIES } from '../constants/trackingEvents'
import { hasCustomerToken, hasClientToken } from '../auth'

export const getDataLayer = () => window.dataLayer

const defaultOptions = {
  eventLabel: undefined,
  eventValue: undefined,
}

const getUserModel = () => {
  if (hasCustomerToken()) {
    return 'customer'
  }

  if (hasClientToken()) {
    return 'client'
  }
}

export const dispatchEvent = (eventName, opts = {}) => {
  if (!eventName) {
    return
  }

  getDataLayer().push({
    event: 'trackingEvent',
    eventName,
    category: EVENTS_CATEGORIES[eventName],
    ...defaultOptions,
    ...opts,
    userModel: getUserModel(),
  })
}

export const oneTimeTagEventDispatcher = (...args) =>
  once(() => dispatchEvent(...args))
